module.exports = __webpack_public_path__ + "static/netless_black-05146bbe996ddb7357e81fe53aca7991.svg";